import { getOfficeMembers } from '@/libs/mocks/handlers/ap-payee';
import { faker } from '@faker-js/faker/locale/ja';
import { ApReportStatus } from 'ap-openapi';
import { HttpResponse, delay, http } from 'msw';

faker.seed(1);

const getCreateInvoiceReportMock = () => ({
  ap_report_type_id: faker.string.uuid(),
  id: faker.string.uuid(),
  link: '/received_invoices',
  office_member: getOfficeMembers(0),
  searchable_number: faker.string.uuid(),
  status: faker.helpers.arrayElement(Object.values(ApReportStatus)),
});

const getRecentApprovedInvoiceReportsMock = () => {
  const files = faker.helpers.arrayElement([
    `請求書${faker.number.int({
      min: 1,
      max: 2,
    })}.pdf`,
    'image.jpg',
  ]);

  return {
    invoice_reports: Array.from({ length: 10 }, (_, i) => ({
      created_at: faker.date.past().toISOString(),
      id: `${i + 1}`,
      invoice_file: {
        id: files,
        name: `請求書${i + 1}.pdf`,
        byte_size: faker.number.int({ min: 1000, max: 100000 }),
        content_type: 'application/pdf',
        cache_content_url: faker.internet.url(),
      },
      number_without_prefix: `${faker.number.int({ min: 1000, max: 9999 })}`,
      office_member: {
        display_name: faker.person.fullName(),
        id: faker.string.uuid(),
        name: faker.person.fullName(),
      },
      title: '2025年3月_支払依頼_サンプル会社',
    })),
  };
};

const getGetInvoiceFilesReportStatusesMock = () => {
  return [
    {
      value: '1',
      name: '現在承認待ち',
    },
    {
      value: '2',
      name: 'Default value',
    },
    {
      value: '3',
      name: '全ステータス',
    },
    {
      value: '4',
      name: '第一承認待ち',
    },
  ];
};

const getGetInvoiceReportStatusesMock = () => {
  return [
    {
      value: '',
      name: '現在承認待ち',
    },
    {
      value: 'status_all',
      name: '全ステータス',
    },
    {
      value: 'waiting_step_one',
      name: '第一承認待ち',
    },
    {
      value: 'waiting_step_two',
      name: '第二承認待ち',
    },
    {
      value: 'waiting_step_three',
      name: '第三承認待ち',
    },
    {
      value: 'waiting_step_four',
      name: '第四承認待ち',
    },
    {
      value: 'waiting_step_five',
      name: '第五承認待ち',
    },
    {
      value: 'waiting_step_six',
      name: '第八承認待ち',
    },
    {
      value: 'waiting_step_seven',
      name: '第七承認待ち',
    },
    {
      value: 'waiting_step_eight',
      name: '全承認待ち',
    },
    {
      value: 'waiting_step_nine',
      name: '承認済み',
    },
  ];
};

const getReferenceInvoiceTransactionsMock = () => {
  return {
    id: '69EnOKOHg0ojZMWwXxOwmg',
    number_without_prefix: '1',
    title: '20240401_見積書_マネーフォワード',
    detail_invoice_report_path:
      'report_types/cQ0AYGirucwN-IWVnLuRow/invoice_reports/69EnOKOHg0ojZMWwXxOwmg',
    invoice_transactions: [
      {
        id: '69EnOKOHg0ojZMWwXxOwmg',
        number: 'AP1',
        name: 'Bus Fee',
        unit_value: 50000,
        quantity: 1,
        total_value: 60000,
        excise_value: 6000,
        has_withholding_income_tax: false,
        withholding_income_tax_value: 0,
        unit_price_excluding_tax: 50000,
        currency: 'JPY',
        deal_date: '2024-04-01',
        jpyrate: 1,
        use_custom_jpy_rate: false,
        ap_payee_type: 'AP',
        project_code: {
          id: '1',
          name: '支払依頼',
        },
        dr_excise: {
          id: '1',
          name: '支払依頼',
        },
        dept: {
          id: '1',
          name: '支払依頼',
        },
        cr_item: {
          id: '1',
          name: '支払依頼',
        },
        ex_item: {
          id: '1',
          name: '支払依頼',
        },
      },
    ],
  };
};

const getGetOfficeInvoiceReportSettingsMock = () => {
  return {
    instant_payee_setting: {
      enabled: true,
      instant_payee_search_option: {
        id: 'W9tC-6SSZz78qILLGdoQHA',
        label: '［スポット支払］の支払先',
      },
    },
    depts_setting: {
      enabled: true,
    },
    report_depts_setting: {
      enabled: true,
      blank_report_dept_option: {
        id: 'JFGct6CGw7jUsntJ2ekJuw',
        label: '部門なし',
      },
    },
  };
};

export const handlers = [
  http.post(
    '*/api/js/received_invoice/v1/received_invoices/:id/invoice_report',
    async () => {
      await delay(1000);
      const isSuccess = Math.random() % 2 === 0;
      if (isSuccess) {
        return new HttpResponse(JSON.stringify(getCreateInvoiceReportMock()), {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        });
      } else {
        const body = {
          messages: ['支払依頼を作成出来ません'],
        };
        return new HttpResponse(JSON.stringify(body), {
          status: 403,
          headers: {
            'Content-Type': 'application/json',
          },
        });
      }
    }
  ),
  http.get('*/api/js/invoice_reports/reference_recent_approved', async () => {
    await delay(500);
    return new HttpResponse(
      JSON.stringify(getRecentApprovedInvoiceReportsMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
  http.get(
    '*/api/js/invoice_reports/:id/reference_invoice_transactions',
    async () => {
      await delay(500);
      return new HttpResponse(
        JSON.stringify(getReferenceInvoiceTransactionsMock()),
        {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
  ),
  http.get('*/api/js/invoice_reports/statuses', async () => {
    await delay(500);
    return new HttpResponse(JSON.stringify(getGetInvoiceReportStatusesMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
  http.get('*/api/js/invoice_reports/invoice_files/statuses', async () => {
    await delay(500);
    return new HttpResponse(
      JSON.stringify(getGetInvoiceFilesReportStatusesMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
  http.get('*/api/js/office/invoice_report_settings', async () => {
    await delay(500);
    return new HttpResponse(
      JSON.stringify(getGetOfficeInvoiceReportSettingsMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
];
